import { invariant } from '@mimir/common/util/invariant';

export const LOCAL_STAGE_MIMIR_REGION = 'eu-west-1';
export const LOCAL_STAGE_AWS_ACCOUNT_ID = '001122334455';
export const LOCAL_STAGE_AWS_ACCESS_KEY_ID = 'AABBCCDDEEFFGGHHIIJJ';
export const LOCAL_STAGE_AWS_SECRET_ACCESS_KEY = 'aAbBcCdDeEfFgGhHiIjJkKlLmMnNoOpPqQrRsStT'; // NOSONAR: secrets:S6290 Not a real secret
export const LOCAL_STAGE_AWS_IDENTITY_POOL_ID = 'eu-west-1:00112233-4455-6677-8899-aAbBcCdDeEfF';
export const LOCAL_STAGE_AWS_APP_CLIENT_ID = 'aAbBcCdDeEfFgGhHiIjJkKlLmM';
export const LOCAL_STAGE_AWS_USER_POOL_ID = 'eu-west-1_ABCDEFGHI';
export const LOCAL_STAGE_AWS_USER_POOL_NAME = 'LocalStageUserPool';
export const FAKE_BUCKET_NAME_FOR_LOCAL_STAGE = 'FAKE_BUCKET_NAME_FOR_LOCAL_STAGE';

export const ID_OF_MIMIR_ROOT_FOLDER = '00000000-0000-0000-0000-000000000000';

export function isLocalStageAccountId(awsAccountId: string | undefined) {
  return awsAccountId === LOCAL_STAGE_AWS_ACCOUNT_ID;
}

export function isLocalStage() {
  return isLocalStageAccountId(process.env.AWS_ACCOUNT_ID);
}

export function localServicesScheme() {
  return process.env.USE_HTTPS === 'true' ? 'https://' : 'http://';
}

export function shouldFailRequestsOnPolicyViolations() {
  return process.env['LOCAL_STAGE_FAIL_ON_POLICY_VIOLATION'] !== 'false';
}

export function isNonContainerizedLocalStageLambdaEnvironment() {
  return !process.env.LAMBDA_IN_DOCKER && isLocalStage();
}

/**
 * When this returns true, some shortcuts are taken to speed up
 * things for developers, like reducing the interval for polling
 * some events. Change the CHEAT variable to disable these shortcuts.
 */
export function useLocalStageShortcuts() {
  return process.env.CHEAT === 'true';
}

export function getLocalGoogleTranscriptionsBucket(stage: string) {
  return `mb10-mimir-${stage}-google-transcriptions`;
}

export function getLocalGcpConfigBucket(stage: string) {
  return `mb10-mimir-${stage}-gcp-config`;
}

export function getLocalIncomingMediaBucket(stage: string) {
  return `mb10-mimir-${stage}-incoming-media`;
}

export function getIncomingMediaBucket(stage: string) {
  return `mb10-mimir-${stage}-incoming-media`;
}

export function getLocalOpensearchSnapshotsBucket(stage: string) {
  return `mb10-mimir-${stage}-opensearch-snapshots`;
}

export function getSnsIncomingMediaObjectCreatedArn(stage: string) {
  return `arn:aws:sns:${LOCAL_STAGE_MIMIR_REGION}:${LOCAL_STAGE_AWS_ACCOUNT_ID}:mb10-mimir-${stage}-snsIncomingMediaObjectCreated`;
}

export function getSnsIncomingMediaObjectRestoredArn(stage: string) {
  return `arn:aws:sns:${LOCAL_STAGE_MIMIR_REGION}:${LOCAL_STAGE_AWS_ACCOUNT_ID}:restore-media-listener_${getIncomingMediaBucket(stage)}`;
}

export function getSnsGeneratedMediaObjectCreatedArn(stage: string) {
  return `arn:aws:sns:${LOCAL_STAGE_MIMIR_REGION}:${LOCAL_STAGE_AWS_ACCOUNT_ID}:mb10-mimir-${stage}-snsGeneratedMediaObjectCreated`;
}

export function getSnsUserSettingsObjectCreatedArn(stage: string) {
  return `arn:aws:sns:${LOCAL_STAGE_MIMIR_REGION}:${LOCAL_STAGE_AWS_ACCOUNT_ID}:mb10-mimir-${stage}-snsUserSettingsObjectCreated`;
}

export function getSnsLocalStageGeneratedMediaLocationArn() {
  invariant(isLocalStage(), 'Expected local stage environment');
  return `arn:aws:sns:${LOCAL_STAGE_MIMIR_REGION}:${LOCAL_STAGE_AWS_ACCOUNT_ID}:generated-media-listener_${FAKE_BUCKET_NAME_FOR_LOCAL_STAGE}`;
}

export function getLocalS3LogsBucket(stage: string) {
  return `mb10-mimir-${stage}-s3-logs`;
}

export function getLocalGeneratedMediaBucket(stage: string) {
  return `mb10-mimir-${stage}-generated-media`;
}

export function getLocalUserSettingsBucket(stage: string) {
  return `mb10-mimir-${stage}-user-settings`;
}

export function getLocalTranscriptsBucket(stage: string) {
  return `mb10-mimir-${stage}-transcripts`;
}

export function getLocalStaticAssetsBucket(stage: string) {
  return `${stage}.mimir.tv`;
}
